var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _radialGradient, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _radialGradient2, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path3, _path4, _path5, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _path6, _path7, _path8, _circle22, _path9, _path10, _path11, _circle23, _path12, _path13, _circle24, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMotorbike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.953 -.304 .304 .953 -89.323 -25.943)",
    gradientUnits: "userSpaceOnUse",
    x1: 449.03,
    x2: 449.03,
    xlinkHref: "#lg1",
    y1: 439.861,
    y2: 452.622
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.953 -.304 .304 .953 -89.323 -25.943)",
    gradientUnits: "userSpaceOnUse",
    x1: 380.441,
    x2: 380.441,
    xlinkHref: "#lg1",
    y1: 436.268,
    y2: 463.166
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.143,
    x2: 464.807,
    xlinkHref: "#lg1",
    y1: 292.463,
    y2: 355.128
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-1 0 0 -1 -2682 -2682)",
    gradientUnits: "userSpaceOnUse",
    x1: -3137.621,
    x2: -3101.209,
    xlinkHref: "#lg1",
    y1: -3027.942,
    y2: -2991.529
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.175,
    x2: 438.386,
    xlinkHref: "#lg2",
    y1: 301.279,
    y2: 305.491
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.175,
    x2: 438.386,
    xlinkHref: "#lg2",
    y1: 347.711,
    y2: 351.923
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(0 1 -1 0 -2682 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 324.495,
    x2: 328.707,
    xlinkHref: "#lg2",
    y1: -3142.975,
    y2: -3138.764
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(0 1 -1 0 -2682 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 324.495,
    x2: 328.707,
    xlinkHref: "#lg2",
    y1: -3096.543,
    y2: -3092.331
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -1341.009 555.355)",
    gradientUnits: "userSpaceOnUse",
    x1: 1092.755,
    x2: 1096.967,
    xlinkHref: "#lg2",
    y1: -1443.509,
    y2: -1439.297
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -1341.009 555.355)",
    gradientUnits: "userSpaceOnUse",
    x1: 1092.755,
    x2: 1096.967,
    xlinkHref: "#lg2",
    y1: -1397.076,
    y2: -1392.864
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1340.991 555.355)",
    gradientUnits: "userSpaceOnUse",
    x1: -1420.28,
    x2: -1416.068,
    xlinkHref: "#lg2",
    y1: 1069.526,
    y2: 1073.737
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1340.991 555.355)",
    gradientUnits: "userSpaceOnUse",
    x1: -1420.28,
    x2: -1416.068,
    xlinkHref: "#lg2",
    y1: 1115.959,
    y2: 1120.17
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.044,
    x2: 448.069,
    xlinkHref: "#lg2",
    y1: 301.394,
    y2: 342.217
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-1 0 0 -1 -554 510)",
    gradientUnits: "userSpaceOnUse",
    x1: -1010.089,
    x2: -977.1,
    xlinkHref: "#lg2",
    y1: 157.236,
    y2: 200.643
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1551,
    stopColor: "#9b489a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    stopColor: "#84438f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#5e3b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 422.176,
    cy: 310.154,
    gradientUnits: "userSpaceOnUse",
    r: 87.146,
    xlinkHref: "#lg3"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.306,
    x2: 437.668,
    xlinkHref: "#lg2",
    y1: 322.786,
    y2: 328.526
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.209,
    x2: 102.873,
    xlinkHref: "#lg1",
    y1: 292.463,
    y2: 355.128
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-1 0 0 -1 -2682 -2682)",
    gradientUnits: "userSpaceOnUse",
    x1: -2775.688,
    x2: -2739.275,
    xlinkHref: "#lg1",
    y1: -3027.942,
    y2: -2991.529
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.241,
    x2: 76.453,
    xlinkHref: "#lg2",
    y1: 301.279,
    y2: 305.491
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.241,
    x2: 76.453,
    xlinkHref: "#lg2",
    y1: 347.711,
    y2: 351.923
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(0 1 -1 0 -2682 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 324.495,
    x2: 328.707,
    xlinkHref: "#lg2",
    y1: -2781.042,
    y2: -2776.83
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(0 1 -1 0 -2682 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 324.495,
    x2: 328.707,
    xlinkHref: "#lg2",
    y1: -2734.609,
    y2: -2730.398
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -1341.009 555.355)",
    gradientUnits: "userSpaceOnUse",
    x1: 836.827,
    x2: 841.039,
    xlinkHref: "#lg2",
    y1: -1187.581,
    y2: -1183.369
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -1341.009 555.355)",
    gradientUnits: "userSpaceOnUse",
    x1: 836.827,
    x2: 841.039,
    xlinkHref: "#lg2",
    y1: -1141.148,
    y2: -1136.936
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1340.991 555.355)",
    gradientUnits: "userSpaceOnUse",
    x1: -1164.352,
    x2: -1160.14,
    xlinkHref: "#lg2",
    y1: 813.598,
    y2: 817.809
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1340.991 555.355)",
    gradientUnits: "userSpaceOnUse",
    x1: -1164.352,
    x2: -1160.14,
    xlinkHref: "#lg2",
    y1: 860.031,
    y2: 864.242
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.11,
    x2: 86.136,
    xlinkHref: "#lg2",
    y1: 301.394,
    y2: 342.217
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(-1 0 0 -1 -554 510)",
    gradientUnits: "userSpaceOnUse",
    x1: -648.155,
    x2: -615.166,
    xlinkHref: "#lg2",
    y1: 157.236,
    y2: 200.643
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_29_",
    cx: 60.243,
    cy: 310.154,
    gradientUnits: "userSpaceOnUse",
    r: 87.146,
    xlinkHref: "#lg3"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.372,
    x2: 75.735,
    xlinkHref: "#lg2",
    y1: 322.786,
    y2: 328.526
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4f8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b8eac"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.836,
    x2: 105.494,
    xlinkHref: "#lg4",
    y1: 253.187,
    y2: 330.357
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(.948 .319 -.319 .948 49.851 172.207)",
    gradientUnits: "userSpaceOnUse",
    x1: 68.031,
    x2: 79.162,
    xlinkHref: "#lg1",
    y1: 92.637,
    y2: 92.637
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.414,
    x2: 338.934,
    xlinkHref: "#lg2",
    y1: 209.046,
    y2: 240.619
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.451,
    x2: 125.423,
    xlinkHref: "#lg1",
    y1: 168.036,
    y2: 200.611
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.687,
    x2: 246.939,
    xlinkHref: "#lg4",
    y1: 187.811,
    y2: 297.077
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.993,
    x2: 60.89,
    xlinkHref: "#lg5",
    y1: 218.306,
    y2: 211.448
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.438,
    x2: 139.936,
    xlinkHref: "#lg2",
    y1: 176.581,
    y2: 193.652
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(.946 .324 -.324 .946 -60.65 446.788)",
    gradientUnits: "userSpaceOnUse",
    x1: 95.569,
    x2: 153.463,
    xlinkHref: "#lg2",
    y1: -307.853,
    y2: -307.853
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(.946 .324 -.324 .946 -60.65 446.788)",
    gradientUnits: "userSpaceOnUse",
    x1: 134.515,
    x2: 153.463,
    xlinkHref: "#lg2",
    y1: -307.854,
    y2: -307.854
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.34,
    x2: 359.582,
    xlinkHref: "#lg2",
    y1: 307.181,
    y2: 378.311
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.907,
    x2: 358.037,
    xlinkHref: "#lg1",
    y1: 309.828,
    y2: 371.101
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.494,
    x2: 311.154,
    xlinkHref: "#lg5",
    y1: 349.054,
    y2: 292.803
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.99,
    x2: 317.644,
    xlinkHref: "#lg4",
    y1: 52.881,
    y2: 393.651
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.409,
    x2: 251.92,
    xlinkHref: "#lg5",
    y1: 166.078,
    y2: 206.361
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.844,
    x2: 425.344,
    xlinkHref: "#lg4",
    y1: 163.047,
    y2: 190.047
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.392,
    x2: 400.555,
    xlinkHref: "#lg4",
    y1: 175.607,
    y2: 382.465
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 475.274,
    x2: 489.821,
    y1: 201.155,
    y2: 231.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.141,
    x2: 472.418,
    xlinkHref: "#lg6",
    y1: 200.377,
    y2: 209.438
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.012,
    x2: 103.837,
    xlinkHref: "#lg2",
    y1: 115.082,
    y2: 172.78
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.75,
    x2: 73.397,
    xlinkHref: "#lg6",
    y1: 175.029,
    y2: 215.288
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.658,
    x2: 141.467,
    xlinkHref: "#lg5",
    y1: 284.084,
    y2: 314.978
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientTransform: "matrix(.993 -.116 .116 .993 -35.521 -29.106)",
    gradientUnits: "userSpaceOnUse",
    x1: 256.294,
    x2: 269.903,
    xlinkHref: "#lg2",
    y1: 365.381,
    y2: 428.889
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.328,
    x2: 222.803,
    xlinkHref: "#lg5",
    y1: 295.427,
    y2: 283.509
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.619,
    x2: 189.375,
    xlinkHref: "#lg2",
    y1: 284.69,
    y2: 279.208
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.889,
    x2: 267.248,
    xlinkHref: "#lg1",
    y1: 305.383,
    y2: 353.728
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.787,
    x2: 247.368,
    y1: 352.621,
    y2: 311.201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.32,
    x2: 260.302,
    xlinkHref: "#lg1",
    y1: 313.053,
    y2: 329.112
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.389,
    x2: 260.111,
    xlinkHref: "#lg4",
    y1: 335.053,
    y2: 378.602
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m506.544 258.566-61.066 19.503c-2.613.834-5.407-.607-6.241-3.22l-2.569-8.044c-.834-2.612.607-5.407 3.22-6.241l61.066-19.502c2.613-.834 5.407.607 6.241 3.22l2.569 8.044c.834 2.611-.608 5.405-3.22 6.24z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m478.126 278.326-128.712 41.107c-5.507 1.759-11.396-1.28-13.155-6.786l-5.415-16.954c-1.759-5.507 1.28-11.396 6.786-13.155l128.712-41.107c5.507-1.759 11.396 1.28 13.155 6.786l5.415 16.954c1.759 5.506-1.279 11.396-6.786 13.155z",
    fill: "url(#SVGID_2_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 435.967,
    cy: 326.287,
    fill: "url(#SVGID_3_)",
    r: 29.542
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.967,
    cy: 326.287,
    fill: "url(#SVGID_4_)",
    r: 17.166
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.967,
    cy: 303.071,
    fill: "url(#SVGID_5_)",
    r: 3.418
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.967,
    cy: 349.504,
    fill: "url(#SVGID_6_)",
    r: 3.418
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.183,
    cy: 326.287,
    fill: "url(#SVGID_7_)",
    r: 3.418
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.75,
    cy: 326.287,
    fill: "url(#SVGID_8_)",
    r: 3.418
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.383,
    cy: 309.871,
    fill: "url(#SVGID_9_)",
    r: 3.418
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 419.55,
    cy: 342.704,
    fill: "url(#SVGID_10_)",
    r: 3.418
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 419.55,
    cy: 309.871,
    fill: "url(#SVGID_11_)",
    r: 3.418
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.383,
    cy: 342.704,
    fill: "url(#SVGID_12_)",
    r: 3.418
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m444.132 263.154v-.501h-16.331v.501c-32.622 3.878-57.884 30.655-57.884 63.134 0 35.145 29.571 63.635 66.049 63.635s66.049-28.491 66.049-63.635c.001-32.48-25.261-59.256-57.883-63.134zm37.311 63.133c0 1.76-.109 3.495-.32 5.199-.385 3.114-3.73 4.928-6.587 3.631l-30.403-13.811v-32.141c0-3.169 3.085-5.438 6.105-4.477 18.123 5.766 31.205 22.206 31.205 41.599zm-53.642-37.122v32.141l-30.403 13.811c-2.857 1.298-6.202-.517-6.587-3.631-.211-1.705-.32-3.44-.32-5.199 0-19.393 13.082-35.833 31.205-41.599 3.02-.96 6.105 1.308 6.105 4.477zm8.166 80.936c-12.617 0-24.03-4.954-32.267-12.95-2.349-2.28-1.603-6.232 1.378-7.586l30.889-14.031 30.889 14.031c2.981 1.354 3.727 5.305 1.378 7.586-8.237 7.996-19.65 12.95-32.267 12.95z",
    fill: "url(#SVGID_13_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m435.967 393.944c38.783 0 70.223-30.291 70.223-67.656s-31.44-67.656-70.223-67.656-70.223 30.291-70.223 67.656 31.44 67.656 70.223 67.656zm0-114.239c26.703 0 48.349 20.855 48.349 46.582s-21.647 46.582-48.349 46.582c-26.703 0-48.349-20.855-48.349-46.582-.001-25.726 21.646-46.582 48.349-46.582z",
    fill: "url(#SVGID_14_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m435.967 254.96c-40.887 0-74.033 31.935-74.033 71.327s33.146 71.327 74.033 71.327 74.033-31.934 74.033-71.327-33.146-71.327-74.033-71.327zm0 120.437c-28.152 0-50.973-21.987-50.973-49.11s22.821-49.11 50.973-49.11 50.973 21.987 50.973 49.11-22.822 49.11-50.973 49.11z",
    fill: "url(#SVGID_15_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.967,
    cy: 326.287,
    fill: "url(#SVGID_16_)",
    r: 9.073
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.033,
    cy: 326.287,
    fill: "url(#SVGID_17_)",
    r: 29.542
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.033,
    cy: 326.287,
    fill: "url(#SVGID_18_)",
    r: 17.166
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.033,
    cy: 303.071,
    fill: "url(#SVGID_19_)",
    r: 3.418
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.033,
    cy: 349.504,
    fill: "url(#SVGID_20_)",
    r: 3.418
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.25,
    cy: 326.287,
    fill: "url(#SVGID_21_)",
    r: 3.418
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.817,
    cy: 326.287,
    fill: "url(#SVGID_22_)",
    r: 3.418
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.45,
    cy: 309.871,
    fill: "url(#SVGID_23_)",
    r: 3.418
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.617,
    cy: 342.704,
    fill: "url(#SVGID_24_)",
    r: 3.418
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.617,
    cy: 309.871,
    fill: "url(#SVGID_25_)",
    r: 3.418
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.45,
    cy: 342.704,
    fill: "url(#SVGID_26_)",
    r: 3.418
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m82.199 263.154v-.501h-16.331v.501c-32.622 3.878-57.884 30.655-57.884 63.134 0 35.145 29.571 63.635 66.049 63.635s66.049-28.491 66.049-63.635c.001-32.48-25.261-59.256-57.883-63.134zm37.31 63.133c0 1.76-.109 3.495-.32 5.199-.385 3.114-3.73 4.928-6.587 3.631l-30.403-13.811v-32.141c0-3.169 3.085-5.438 6.105-4.477 18.123 5.766 31.205 22.206 31.205 41.599zm-53.641-37.122v32.141l-30.403 13.811c-2.857 1.298-6.202-.517-6.587-3.631-.211-1.705-.32-3.44-.32-5.199 0-19.393 13.082-35.833 31.205-41.599 3.02-.96 6.105 1.308 6.105 4.477zm8.165 80.936c-12.617 0-24.03-4.954-32.267-12.95-2.349-2.28-1.603-6.232 1.378-7.586l30.889-14.031 30.889 14.031c2.981 1.354 3.727 5.305 1.378 7.586-8.237 7.996-19.65 12.95-32.267 12.95z",
    fill: "url(#SVGID_27_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m74.033 393.944c38.783 0 70.223-30.291 70.223-67.656s-31.44-67.656-70.223-67.656-70.223 30.291-70.223 67.656 31.44 67.656 70.223 67.656zm0-114.239c26.703 0 48.349 20.855 48.349 46.582s-21.647 46.582-48.349 46.582c-26.703 0-48.349-20.855-48.349-46.582 0-25.726 21.647-46.582 48.349-46.582z",
    fill: "url(#SVGID_28_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m74.033 254.96c-40.887 0-74.033 31.934-74.033 71.327s33.146 71.327 74.033 71.327 74.033-31.934 74.033-71.327-33.145-71.327-74.033-71.327zm0 120.437c-28.152 0-50.973-21.987-50.973-49.11s22.821-49.11 50.973-49.11 50.973 21.987 50.973 49.11-22.821 49.11-50.973 49.11z",
    fill: "url(#SVGID_29_)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.033,
    cy: 326.287,
    fill: "url(#SVGID_30_)",
    r: 9.073
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m32.074 263.35 29.618 11.579c5.864 2.293 9.724 7.945 9.724 14.242 0 6.176 3.716 11.746 9.418 14.119l8.914 3.708c4.176 1.737 8.999.448 11.751-3.141 5.206-6.789 14.157-9.51 22.261-6.768l17.778 6.017c4.346 1.471 8.639-2.356 7.673-6.842-9.123-42.4-54.427-66.176-94.504-49.599l-22.705 9.392c-3.271 1.353-3.226 6.004.072 7.293z",
    fill: "url(#SVGID_31_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m72.873 330.095c-3.704-1.248-5.694-5.262-4.446-8.966l27.034-80.717c1.248-3.704 5.262-5.694 8.966-4.446 3.704 1.248 5.694 5.262 4.446 8.966l-27.034 80.717c-1.248 3.703-5.263 5.694-8.966 4.446z",
    fill: "url(#SVGID_32_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m302.257 210.958c4.727 2.958 10.709 3.035 15.51.198l22.145-13.086c11.747-6.941 25.142-10.603 38.786-10.603h22.162l-69.951 69.951h-68.318l18.158-39.979c3.734-8.221 13.854-11.271 21.508-6.481z",
    fill: "url(#SVGID_33_)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.712,
    cy: 185.655,
    fill: "url(#SVGID_34_)",
    r: 26.412
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m135.691 189.196 27.614-11.751c36.77-15.648 79.259-8.763 109.206 17.695l7.665 6.772c4.434 3.917 5.653 10.34 2.962 15.61l-16.999 33.292c-1.302 2.55-3.923 4.154-6.786 4.154h-146.84v-30.718c0-15.275 9.123-29.072 23.178-35.054z",
    fill: "url(#SVGID_35_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m280.176 201.912-7.665-6.772c-6.316-5.58-13.195-10.279-20.456-14.09l-55.595 28.764c-10.183 5.269-16.578 15.777-16.578 27.242v17.912h79.471c2.863 0 5.484-1.605 6.786-4.154l16.999-33.292c2.691-5.27 1.472-11.693-2.962-15.61z",
    fill: "url(#SVGID_36_)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.201,
    cy: 188.55,
    fill: "url(#SVGID_37_)",
    r: 15.699
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m171.212 211.516-35.456-12.125c-5.336-1.825-8.183-7.63-6.358-12.967 1.825-5.336 7.63-8.183 12.967-6.358l35.455 12.125c5.336 1.825 8.183 7.63 6.358 12.967-1.825 5.336-7.63 8.182-12.966 6.358z",
    fill: "url(#SVGID_38_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m171.212 211.516 1.396.477c-5.336-1.825-8.183-7.63-6.358-12.966 1.825-5.336 7.63-8.183 12.967-6.358l-1.396-.477c5.336 1.825 8.183 7.63 6.358 12.967-1.826 5.335-7.631 8.181-12.967 6.357z",
    fill: "url(#SVGID_39_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m433.337 347.795h-169.806c-11.878 0-21.507-9.629-21.507-21.507 0-11.878 9.629-21.507 21.507-21.507h169.805c11.878 0 21.507 9.629 21.507 21.507.001 11.878-9.628 21.507-21.506 21.507z",
    fill: "url(#SVGID_40_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m263.531 342.351c-8.858 0-16.064-7.206-16.064-16.064 0-8.857 7.206-16.064 16.064-16.064h169.806c8.858 0 16.063 7.207 16.063 16.064 0 8.858-7.205 16.064-16.063 16.064z",
    fill: "url(#SVGID_41_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m335.895 347.795h61.798l-42.927-42.928-.109-.087h-18.762z",
    fill: "url(#SVGID_42_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m132.337 112.385c-20.467 0-40.008 9.376-53.594 25.907-13.348 16.243-26.863 38.568-26.863 62.382 0 11.634 92.136 132.535 92.136 132.535 11.621 17.089 30.076 27.189 49.711 27.189l137.045-.002c10.16 0 18.396-8.894 18.396-19.865 0-42.635 24.305-80.87 61.15-96.192 26.783-11.138 55.395-23.036 69.999-29.108 5.917-2.46 9.814-8.598 9.814-15.444 0-12.085-9.066-21.882-20.257-21.883-23.405-.002-61.194-.002-80.719-.002-8.058 0-15.778 3.456-21.476 9.609l-15.952 24.427c-16.793 25.715-44.115 41.011-73.254 41.011h-69.23c-22.447 0-43.891-10.047-59.225-27.749l-21.153-24.418c-13.198-15.236-12.895-39.008.687-53.846 6.523-7.044 10.187-16.597 10.187-26.558-.002-4.415-3.315-7.993-7.402-7.993z",
    fill: "url(#SVGID_43_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m130.231 120.376c0 9.961-3.665 19.514-10.187 26.558-13.582 14.838-13.885 38.61-.687 53.846l21.153 24.418c15.335 17.702 36.778 27.749 59.225 27.749h9.507c-22.447 0-43.891-10.047-59.225-27.749l-21.153-24.418c-13.198-15.236-12.895-39.008.686-53.846 6.523-7.044 10.187-16.597 10.187-26.558 0-4.413-3.313-7.991-7.4-7.991-2.418 0-4.821.141-7.205.399 2.96 1.046 5.099 4.048 5.099 7.592z",
    fill: "url(#SVGID_44_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m465.509 187.467h-80.009c0-12.132 9.835-21.967 21.967-21.967h36.076c12.131 0 21.966 9.835 21.966 21.967z",
    fill: "url(#SVGID_45_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m150.016 225.199-14.035-16.201c1.575 3.713 3.712 7.219 6.433 10.36l21.153 24.418c15.335 17.702 36.778 27.748 59.225 27.748h69.23c29.14 0 56.461-15.296 73.255-41.011l15.952-24.427c5.698-6.153 13.418-9.609 21.476-9.609 19.525 0 57.314.001 80.719.002 2.318 0 4.535.441 6.608 1.215-.975-11.103-9.622-19.791-20.159-19.792-23.405-.002-61.194-.002-80.719-.002-8.058 0-15.778 3.456-21.476 9.609l-15.952 24.427c-16.793 25.715-44.115 41.011-73.254 41.011h-69.23c-22.448 0-43.891-10.047-59.226-27.748z",
    fill: "url(#SVGID_46_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m462.601 207.473c0 7.197 7.319 12.08 13.965 9.317l3.752-1.56c5.917-2.46 9.814-8.598 9.814-15.444 0-1.127-.103-2.226-.256-3.308h-16.279c-6.074 0-10.996 4.923-10.996 10.995z",
    fill: "url(#SVGID_47_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m474.707 196.478h-.702c-6.091 0-10.889 3.849-11.357 9.98-.044.576-.062 1.138-.026 1.686.491 7.657 12.085 7.051 12.085-.622z",
    fill: "url(#SVGID_48_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m56.553 175.611.048.015c9.892 3.105 20.626-.589 26.585-9.074 10.789-15.362 30.277-39.055 54.831-51.295-1.357-1.754-3.397-2.872-5.68-2.872-20.467 0-40.008 9.376-53.594 25.907-8.515 10.362-17.091 23.2-22.19 37.319z",
    fill: "url(#SVGID_49_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m83.031 200.836 1.666-3.709c3.389-7.546-2.131-16.077-10.403-16.077h-19.515c-1.831 6.356-2.899 12.931-2.899 19.624 0 1.85 2.335 6.469 6.252 12.917h5.186c8.509 0 16.226-4.993 19.713-12.755z",
    fill: "url(#SVGID_50_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m365.744 190.471-14.018 21.465c-16.793 25.715-44.115 41.011-73.254 41.011h-13.504l-24.966 45.487c-6.009 10.948-2.652 24.673 7.733 31.611l45.43 30.352h37.607c10.16 0 18.396-8.894 18.396-19.865 0-21.193 6.01-41.296 16.576-58.04z",
    fill: "url(#SVGID_51_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m240 299.07c-6.123 10.592-2.959 24.118 7.227 30.895l28.347 18.862c2.843 1.91 6.275 2.741 9.677 2.344 7.881-.92 13.525-8.055 12.605-15.936l-.606-5.191c-1.938-16.605-13.512-30.493-29.496-35.392l-14.866-4.557c-3.828-1.173-7.96.451-9.964 3.918z",
    fill: "url(#SVGID_52_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m145.7 269.618-58.552-13.288c9.447 13.216 19.532 26.971 28.55 39.136 2.183 2.587 4.195 5.298 6.031 8.114 12.839 17.229 22.288 29.628 22.288 29.628.679.999 1.386 1.968 2.111 2.918l14.894-37.384c4.92-12.352-2.354-26.181-15.322-29.124z",
    fill: "url(#SVGID_53_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m145.7 269.618-16.185-3.673c-2.017-.458-3.261 2.132-1.641 3.42l11.614 9.236c7.358 5.851 12.729 13.832 15.38 22.852l.092.314c.676 2.301 3.88 2.451 4.767.222l1.293-3.246c4.922-12.353-2.352-26.182-15.32-29.125z",
    fill: "url(#SVGID_54_)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m281.15 320.487c0 1.557-.131 3.092-.381 4.573-.152.882-.337 1.753-.577 2.602-.065.283-.142.577-.24.86-.022.098-.054.207-.098.305-.087.316-.196.631-.305.947-.044.087-.065.174-.098.261-.153.392-.305.784-.468 1.165-.207.49-.425.969-.664 1.448-.141.283-.283.566-.435.849-.043.076-.076.152-.12.229-.153.272-.305.544-.468.817-.871 1.459-1.862 2.82-2.983 4.094-.141.174-.294.348-.468.523-.49.533-1.013 1.056-1.546 1.546-.229.218-.457.425-.686.621-.033.022-.065.054-.098.076-.24.218-.49.425-.751.621-.838.675-1.709 1.285-2.624 1.851l-11.54-7.676-9.374-6.228c-4.605-3.07-7.773-7.523-9.298-12.455-1.851-5.966-1.285-12.64 2.069-18.443l2.047-3.538c3.527-1.644 7.447-2.559 11.595-2.559 15.198-.001 27.511 12.312 27.511 27.511z",
    fill: "url(#SVGID_55_)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m280.769 325.06c-.152.882-.337 1.753-.577 2.602-.065.283-.142.577-.24.86-.022.098-.054.207-.098.305-.087.316-.196.631-.305.947-.044.087-.065.174-.098.261-.153.392-.305.784-.468 1.165-.207.49-.425.969-.664 1.448-.141.283-.283.566-.435.849-.043.076-.076.152-.12.229-.153.272-.305.544-.468.817-.871 1.459-1.862 2.82-2.983 4.094-.141.174-.294.348-.468.523-.49.533-1.013 1.056-1.546 1.546-.229.218-.457.425-.686.621-.033.022-.065.054-.098.076-.24.218-.49.425-.751.621-.838.675-1.709 1.285-2.624 1.851l-11.54-7.676-9.374-6.228c-4.605-3.07-7.773-7.523-9.298-12.455 1.394-7.403 7.893-13.01 15.71-13.01.555 0 1.1.033 1.633.087.272.022.534.054.806.098.348.054.697.12 1.045.196.218.055.435.109.653.163 2.907.784 5.476 2.373 7.479 4.496z",
    fill: "url(#SVGID_56_)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m269.621 320.487c0 7.817-5.607 14.328-13.021 15.71l-9.374-6.228c-4.605-3.07-7.773-7.523-9.298-12.455 1.394-7.403 7.893-13.01 15.71-13.01.555 0 1.1.033 1.633.087.272.022.534.054.806.098.348.054.697.12 1.045.196.218.055.435.109.653.163 3.081.817 5.792 2.537 7.839 4.856 2.493 2.82 4.007 6.522 4.007 10.583z",
    fill: "url(#SVGID_57_)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m352.782 366.642s-.011 0-.011.011c-.196.327-.436.631-.697.904-.185.207-.392.392-.621.577-.174.141-.359.283-.566.392-.893.577-1.982.915-3.212.915h-172.617c-6.119 0-10.757-5.008-10.757-10.724 0-1.089.163-2.199.523-3.31l.044-.131c2.45-7.73 9.548-13.054 17.659-13.054h108.099c.653.109 1.317.185 2.003.185h18.977c6.14 0 12.183.991 17.899 2.885.305.098.61.207.915.305 1.448.512 2.874 1.067 4.268 1.688.37.163.729.327 1.089.501 3.005 1.394 5.879 3.059 8.601 4.975.207.142.414.283.61.435.185.131.381.261.566.414.37.272.751.555 1.121.849 1.829 1.415 3.582 2.961 5.237 4.616.316.316.577.642.806.98 1.414 2.091 1.272 4.66.064 6.587z",
    fill: "url(#SVGID_58_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMotorbike);
export default __webpack_public_path__ + "static/media/icon-motorbike.ff1a4d2925e49380f43fde1a9425ab55.svg";
export { ForwardRef as ReactComponent };